import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import { Add } from '@mui/icons-material'
import { useLang } from '~/hooks/useLang'

export default function SaveButton({ canCreate, create }) {
  const { translate } = useLang()

  return (
    <Grid item>
      <Tooltip
        title={translate('New Entry')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton
            disabled={!canCreate}
            onClick={() => (create ? create() : false)}
          >
            <Add />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
